import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { GlobalService } from 'src/app/api/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'underscore';
import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';
import { environment } from 'src/app/environment';
import AlertifyHelper from 'src/app/utils/utils';
import { NavigationTrackerService } from 'src/app/utils/navigation-tracker.service';
import { HotelService } from 'src/app/api/tourism/hotel.service';
import { ToolsService } from 'src/app/utils/tools.service';
declare var $: any;

@Component({
  selector: 'app-hotel-gallery-video',
  templateUrl: './hotel-gallery-video.component.html',
  styleUrls: ['./hotel-gallery-video.component.css']
})
export class HotelGalleryVideoComponent {
  branchofficeSlug: string = '';
  nameMenu: string = 'gallery_video';
  checkId: number;
  item: FormGroup;
  submitted: boolean = false;
  txtSubmenu: string = environment.txt_create_menu_form;
  isEdit: boolean = false;

  videosUpload: any = [];
  videosOld: any = [];

  constructor(
    public fb: FormBuilder,
    private router: Router,
    private routeActivated: ActivatedRoute,
    private el: ElementRef,
    private renderer: Renderer2,
    private globalService: GlobalService,
    private hotelService: HotelService,
    private navigationTrackerService: NavigationTrackerService,
    private alertifyMsg: AlertifyHelper,
    private toolsService: ToolsService
  ) {
    this.branchofficeSlug = this.globalService.slugBranchoffice;
    this.checkId = this.routeActivated.snapshot.params['id'];
    this.item = this.fb.group({
      tradename: ['', [Validators.required, Validators.minLength(2)]]
    });

    if (!_.isUndefined(this.checkId)) {
      this.txtSubmenu = environment.txt_edit_menu_form;
      this.isEdit = true;
    }
  }

  ngOnInit() {
    this.navigationTrackerService.initializeMenu(this.routeActivated);
    if (this.isEdit) {
      this.editData();
    }
  }

  editData() {
    this.hotelService.get(this.checkId).subscribe({
      next: (data: any) => {
        let _item = data.data;
        this.item.patchValue({
          tradename: _item.tradename
        });

        this.videosUpload = _item.gallery_video;
        for (let i = 0; i < this.videosUpload.length; i++) {
          if (
            this.toolsService.isStringContainsIframe(
              this.videosUpload[i].iframe_video
            )
          ) {
            this.videosUpload[i].is_generate_iframe = true;
          } else {
            this.videosUpload[i].is_generate_iframe = false;
          }
        }
      }
    });
  }

  addItemVideo() {
    let obj_: any = {};
    obj_.hotels_id = null;
    obj_.iframe_video = null;
    obj_.title = null;
    obj_.is_generate_iframe = false;
    this.videosUpload.push(obj_);
  }

  changeIframeVideo(param: any, index: number): void {
    this.videosUpload[index].iframe_video = param.value;
    if (
      this.toolsService.isStringContainsIframe(
        this.videosUpload[index].iframe_video
      )
    ) {
      this.videosUpload[index].is_generate_iframe = true;
    } else {
      this.videosUpload[index].is_generate_iframe = false;
    }
  }

  changeTitleVideo(param: any, index: number): void {
    this.videosUpload[index].title = param.value;
  }

  removeVideo(index: any) {
    this.videosUpload.splice(index, 1);
  }

  onSubmit() {
    this.submitted = true;
    if (this.item.invalid) {
      return;
    }
    if (this.validate()) {
      let data: any = {};
      data.item = this.item.value;
      data.videos = this.videosUpload;
      // console.log(data);
      this.hotelService.updateVideo(this.checkId, data).subscribe({
        next: (data: any) => {
          this.alertifyMsg.success('Registro actualizado con éxito');
          // this.router.navigate([
          //   this.branchofficeSlug + '/turismo/hoteles/lista'
          // ]);
        }
      });
    }
  }

  validate() {
    //  validate type bedrooms
    if (this.videosUpload.length == 0) {
      this.alertifyMsg.warning(
        'Debe agregar al menos un registro de iframe de video.'
      );
      return false;
    } else {
      for (let i in this.videosUpload) {
        let _video = this.videosUpload[i];
        let _element_ifrane_video = this.el.nativeElement.querySelector(
          '#iframe_video' + i
        );
        if (_.isNull(_video.iframe_video)) {
          this.alertifyMsg.warning(
            "El campo 'iframe video' no puede estar vacío."
          );
          this.renderer.selectRootElement(_element_ifrane_video).focus();
          return false;
        }

        if (!this.toolsService.isStringContainsIframe(_video.iframe_video)) {
          this.alertifyMsg.warning(
            'Debe ingresar un contenido válido para el iframe del video'
          );
          this.renderer.selectRootElement(_element_ifrane_video).focus();
          return false;
        }
      }
    }

    return true;
  }

  cancel() {
    this.router.navigate([this.branchofficeSlug + '/turismo/hoteles/lista']);
  }

  refresh() {
    this.editData();
  }
}
